<template>
  <div>
    <section-title id="mon-qr-code">
      {{ sectionTitle }}
    </section-title>
    <b-card class="mb-3 shadow">
      {{ $t("planning-page-remote-description") }}
      <div slot="footer">
        <b-btn variant="primary" size="sm" v-b-modal.qr-code>
          <svgicon icon="play" class="mr-1"></svgicon>
          {{ $t("planning-page-remote-generate-btn") }}
        </b-btn>
      </div>
    </b-card>
    <b-modal
      id="qr-code"
      title="QR Code"
      :cancel-title="$t('planning-page-remote-cancel-btn')"
      :noCloseOnBackdrop="false"
    >
      <vita-qr-code @qrCodeString="getQrCode" ref="vitaQrCode"></vita-qr-code>

      <b-btn v-if="isQRCodeReady" variant="primary" @click="openInANewTab"
        >{{ $t("planning-page-remote-generate-print-btn") }}
      </b-btn>
    </b-modal>
  </div>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import VitaQrCode from "./QrCode/QrCode.vue";

export default {
  components: {
    SectionTitle,
    VitaQrCode
  },
  props: ["sectionTitle"],
  data() {
    return {
      isQRCodeReady: false
    };
  },
  methods: {
    openInANewTab() {
      let routeData = this.$router.resolve({ name: "code" });
      window.open(routeData.href, "_blank");
    },
    getQrCode(newQrCodeString) {
      if (newQrCodeString !== "") {
        this.isQRCodeReady = true;
      }
    }
  }
};
</script>

<style>
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
